import { selectorFamily } from "recoil";

import { StripeProductDto, ViewerDto } from "graphql/generated";
import graphQLClient from "graphql/react-query";
import * as fragments from "src/constants/graph-queries";

const query = `
${fragments.stripeProductFragment}
query stripeProduct($input: StripeProductFilterV2) {
  viewer {
    user {
      stripeProducts(input: $input) {
        ...FStripeProduct
      }
    }
  }
}`;

export const productItemState = selectorFamily<StripeProductDto, string>({
  key: "productItemState",
  get: (id: string) => async () => {
    const { viewer } = await graphQLClient.request<{ viewer: ViewerDto }>(query, {
      input: {
        id
      }
    });

    return viewer?.user?.stripeProducts?.[0] || null;
  }
});
